import { notifications } from "@marketplace/ui/notifications";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { logout as abortAndLogout } from "@/http/http-client-utils";

import { usePostLogoutMutation } from "./mutations/use-post-logout-mutation";

export const useLogout = () => {
  const { t } = useTranslation("auth");
  const { mutateAsync } = usePostLogoutMutation();
  const queryClient = useQueryClient();

  return async () => {
    try {
      const res = await mutateAsync();

      if (res && !res.errors) {
        notifications.show({
          message: t("notification.logout.logoutSuccess")
        });
      }
    } catch {
      notifications.show({
        variant: "error",
        message: t("notification.logout.logoutFailed")
      });
    } finally {
      // Abort all HTTP requests and reset router context
      await abortAndLogout();

      // Cancel all React Query queries
      await queryClient.cancelQueries();

      // Clear all React Query cache
      queryClient.clear();
    }
  };
};
